<template>
  <footer class="footer bg-tawi-primary">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 text-white">
          <h4>OFFICE ADDRESS</h4>
          <ul class="list-unstyled align-items-left">
            <li>
              {{ getDetails('Office Address') }}
            </li>
          </ul>
        </div>
        <div class="col-lg-4 text-white">
          <h4>EMAIL ADDRESS</h4>
          <ul class="list-unstyled align-items-left">
            <li>
              {{ getDetails('E-mail Address') }}
            </li>
          </ul>
        </div>
        <div class="col-lg-4 text-white">
          <h4>CONTACT NUMBER</h4>
          <ul class="list-unstyled align-items-left">
            <li>{{ getDetails('Mobile Number 1') }}</li>
            <li>{{ getDetails('Mobile Number 2') }}</li>
          </ul>
        </div>
      </div>
      <br />
      <div class="row justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy;
            <span>TAWItech 2023. All right reserved.</span>
          </div>
        </div>
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item mx-1">
              <a href="https://www.linkedin.com/company/tawitech/" target="_blank">
                <img src="img/buttons/optimized/linkedin.png" class="social-icon" alt="linkedin" /></a>
            </li>
            <li class="nav-item mx-1">
              <a href="https://www.facebook.com/tawitechinc" target="_blank">
                <img src="img/buttons/optimized/facebook.png" class="social-icon" alt="facebook" /></a>
            </li>
            <li class="nav-item mx-1">
              <a href="https://www.instagram.com/tawitech.inc/" target="_blank">
                <img src="img/buttons/optimized/instagram.png" class="social-icon" alt="instagram" /></a>
            </li>
            <li class="nav-item mx-1">
              <a href="https://www.tiktok.com/@tawitech.inc" target="_blank">
                <img src="img/buttons/optimized/tiktok.png" class="social-icon" alt="tiktok" /></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
// API & DAO
import salesContactsDAO from '../database/salesContacts';

// Others
import _ from 'lodash';

export default {
  name: "app-footer",
  data() {
    return {
      allContactsObj: {},
      year: new Date().getFullYear(),
    };
  },
  async mounted() {
    await this.getAllSalesContacts();
  },
  methods: {
    async getAllSalesContacts() {
      this.allContactsObj = await salesContactsDAO.retrieveAll();
    },
    getDetails(contactType) {
      const details = _.find(this.allContactsObj, obj => obj.contactType === contactType);
      return details ? details.details : 'Not found';
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins");

h4 {
  color: white;
  font-weight: bold;
}

li {
  color: white;
  font-size: 20px;
}

.copyright {
  font-size: 20px !important;
  color: white;
}

.social-icon {
  height: 30px;
}

@media only screen and (max-width: 768px) and (min-width: 375px) {
  footer {
    padding: 40px 10px 10px 10px;
  }

  h4 {
    font-size: 20px;
  }

  li {
    font-size: 14px;
  }

  .copyright {
    font-size: 14px !important;
  }
}
</style>
